<section class="mu-home">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
                <div class="col-12">
                    <div class="row">
                        <app-greeting></app-greeting>

                        <div class="col-12 col-md-4 tptxt-gbdpg">
                            <h4>Government Business Tracker</h4>
                        </div>

                        <div class="col-12 col-md-8 right-align">
                            <app-view-for-selector class = "display-inline"(dataEvent)="handleViewForData($event)"></app-view-for-selector>
                            <button type="button" [routerLink]="'/government-business/new'" class="btn-actvtytp text-decoration-none justify-content-end gbdpg-righttxt display-inline"> Create
                                New GB Task </button>
                        </div>
                        <app-stats-card-group class="row row-cols-2 row-cols-lg-4 g-2 g-lg-3 mx-0 mt-0"
                                              [statsCountMap]="statusCountMap"
                                              [statsCards]="statsCards"></app-stats-card-group>
                        <div class="col-12 my-3 text-end align-self-end mt-3"><a><button type="button"
                                    class="btngbdpg-viwall" (click)="viewSummary()">VIEW ALL <img
                                        src="./assets/images/svg/full-rarrow.svg" class="img-fluid"
                                        alt="..."></button></a>
                        </div>
                        <div class="col-12 col-md-6 tptxt-gbdpg">
                            <h4>Pending GB Tasks </h4>
                        </div>
                        <app-pending-items-table [columns]="pendingItemsTableColumns"
                            [data]="pendingItemsList" [routeTo]="routingLink"></app-pending-items-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>